import React, { useContext,useEffect, useState } from 'react'
import { Container, Box, Flex } from 'theme-ui'
import pageContextProvider from '@helpers/pageContextProvider'
import Search from '@widgets/Search'
import { HeaderLogo } from './Header.Logo'
import { HeaderMenu } from './Header.Menu'
import { HeaderColorMode } from './Header.ColorMode'

const styles = {
  wrapper: {
    position: `relative`,
    bg: `headerBg`
  },
  container: {
    position: `relative`,
    zIndex: 10
  },
  logoContainer: {
    flexBasis: [`full`, null, `1/3`]
  },
  searchContainer: {
    flexBasis: [`auto`, null, `1/3`],
    minWidth: `auto`,
    order: [3, null, `unset`],
    display: [`none`, null, `block`],
    mx: 3
  },
  menuContainer: {
    flexBasis: [`auto`, null, `1/3`],
    minWidth: `auto`,
    order: [4, null, `unset`]
  },
  colorModeContainer: {
    minWidth: `auto`,
    order: [2, null, `unset`]
  }
}

const loadGSearch = (callback, shouldLoad) => {
  if (!shouldLoad) {
    return;
  }

  /*if (shouldLoad) {
    return;
  }*/
  const existingScript = document.getElementById('googleCSEScript');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://cse.google.com/cse.js?cx=41556f23372ed4949';
    script.async = true;
    script.id = 'googleCSEScript';
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};

export const Header = ({ children }) => {
  const context = useContext(pageContextProvider)
  const { services, mobileMenu, darkMode } = context.pageContext
  const algolia = services && services.algolia
  const myHTML = `<div class="gcse-searchbox-only"></div>`;
  const [loaded, setLoaded] = useState(false);
  const [inIframe, setInIframe] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      try {
        setInIframe( window.self !== window.top);
      } catch (e) {
        setInIframe(true);
      }
    }
  });

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        const shouldLoad = window.matchMedia('(min-width: 768px)').matches;
        if (!loaded && shouldLoad) {
          loadGSearch(() => {
            setLoaded(true);
          }, shouldLoad);
        }
      };

      window.addEventListener('resize', handleResize);
      handleResize();

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [loaded]);


  return (
      <Box sx={styles.wrapper} className={inIframe ? "in-iframe" : ""}>
        <Container variant='compact' sx={styles.container}>
          <Flex variant='layout.header'>
            <Box sx={styles.logoContainer}>
              <HeaderLogo />
            </Box>
            <Box sx={styles.searchContainer}>
              <div className="search-component">
                {loaded && <div dangerouslySetInnerHTML={{ __html: myHTML }} />}
              </div>
              {algolia && <Search />}
            </Box>
            <Box sx={styles.menuContainer}>
              <HeaderMenu mobileMenu={mobileMenu} />
              <div id="google_translate_element"></div>
            </Box>
            <Box sx={styles.colorModeContainer}>
              {darkMode && <HeaderColorMode />}
            </Box>
          </Flex>
        </Container>
        {children}
      </Box>
  );


}
